import { render, staticRenderFns } from "./kehuzhuce.vue?vue&type=template&id=2b671ade&scoped=true"
import script from "./kehuzhuce.vue?vue&type=script&lang=js"
export * from "./kehuzhuce.vue?vue&type=script&lang=js"
import style0 from "./kehuzhuce.vue?vue&type=style&index=0&id=2b671ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b671ade",
  null
  
)

export default component.exports